import { App } from './app'

export const Layout = {
  App,
}
